import React from 'react';

import SnappySearchImage from './src/snappySearch.svg';

import * as Styles from './styles';

export const SnappySearch = () => (
  <Styles.Wrapper>
    <Styles.SnappyAnimation
      src={SnappySearchImage}
      alt="Snappy Search"
    />
  </Styles.Wrapper>
);

export default SnappySearch;
